import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { CtaButtonComponent } from '../cta-button/cta-button.component';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-ideal-state',
  imports: [SectionWrapperComponent, MatIconModule, CtaButtonComponent],
  templateUrl: './ideal-state.component.html',
  styleUrl: './ideal-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IdealStateComponent {
  private readonly siteConfig = inject(SiteConfigService);

  readonly section = this.siteConfig.idealState;
}
